export default __webpack_public_path__ + "static/media/close-icon-white-filled.dc096bff.svg";